import {
  QuickPassSavedSearch,
  QuickPassSavedSearchCriteria,
} from '../_types/quickpass-saved-search'

const defaultQuickPassSavedSearchCriteria: QuickPassSavedSearchCriteria = {
  cities: [],
  priceMin: null,
  priceMax: null,
  bedroomCounts: [],
  bathroomCounts: [],
  propertyTypes: [],
  dwellingScope: 'no-preference',
}

const defaultQuickPassSavedSearch: QuickPassSavedSearch = {
  id: '',
  quickPassUserId: '',
  name: '',
  criteria: defaultQuickPassSavedSearchCriteria,
  frequency: 'daily',
  lastRunAt: null,
  lastMatchListingIds: [],
  notifyOnMatch: true,
  createdAt: 0,
  updatedAt: 0,
}

export { defaultQuickPassSavedSearchCriteria, defaultQuickPassSavedSearch }
